import { useFeatureFlag as useConfigCatFeatureFlag, User } from 'configcat-react';

import { useGlobalContext } from 'store';

export const useFeatureFlag = (featureKey: string, defaultValue: boolean | string | number) => {
  const { user } = useGlobalContext();
  const userIdentifier = new User(user.resellerId);

  const { value, loading } = useConfigCatFeatureFlag(featureKey, defaultValue, userIdentifier);

  return {
    value,
    loading,
  };
};
